import React from "react";
import "./App.css";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Provider as StreetProvider } from "./context/StreetContext";

import Main from "./Components/Main/Main";
import Camera from "./Components/Camera/Camera";
import Location from "./Components/Location/Location";
import Map from "./Components/Map/Map";
import PhotoList from "./Components/PhotoList/PhotoList";

function App() {
  return (
    <div>
      <h1>CLOSED</h1>
    </div>
  );
  return (
    <StreetProvider>
      <Router>
        <div className="App">
          <Switch>
            <Route exact path="/">
              <Main />
            </Route>
            <Route exact path="/location">
              <Location />
            </Route>
            <Route exact path="/camera">
              <Camera />
            </Route>
            <Route exact path="/map">
              <Map />
            </Route>
            <Route exact path="/photolist">
              <PhotoList />
            </Route>
          </Switch>
        </div>
      </Router>
    </StreetProvider>
  );
}

export default App;
